// 上传图片校验插件

/**
 * 文件大小限制
 */
const maxSize = {
  name: 'maxSize',
  errorMsg() {
    return `大小超出限制，请上传小于等于${this.fileSize}mb的文件`
  },
  handle(file) {
    return file.size <= this.fileSize * 1024 * 1024
  },
}

/**
 * 文件类型校验
 */
const fileType = {
  name: 'fileType',
  errorMsg() {
    return `不支持当前格式文件上传，请上传${this.accept}类型的文件`
  },
  handle(file) {
    const fileName = file.name
    const fileTypes = fileName.substr(fileName.lastIndexOf('.')).toLowerCase()
    return this.accept.includes(fileTypes)
  },
}

/**
 * 支持OSS处理的图片校验
 */
const customImg = {
  name: 'customImg',
  errorMsg() {
    return '不支持当前格式文件上传，请上传.jpg,.png,.jpeg类型的文件'
  },
  handle(file) {
    if (this.scannable) {
      const fileName = file.name
      const fileTypes = fileName.substr(fileName.lastIndexOf('.')).toLowerCase()
      const acceptTypes = '.jpg,.png,.jpeg'
      return acceptTypes.includes(fileTypes)
    }
    return true
  },
}

export const validPlugins = [maxSize, fileType, customImg]
